import React from 'react';

const BackgroundShapes: React.FC = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-1 overflow-hidden">
      {/* Left Plant - Hidden on mobile, visible on desktop */}
      <img
        src="/assets/plant-left.png"
        alt="Decorative plant"
        className="fixed top-0 -left-8 w-48 pointer-events-none hidden md:block"
        style={{ 
          zIndex: 1,
          mixBlendMode: 'normal',
          imageRendering: 'auto'
        }}
      />
      
      {/* Right Plant - Hidden on mobile, visible on desktop */}
      <img
        src="/assets/plant-right.png"
        alt="Decorative plant"
        className="fixed top-0 right-0 w-48 pointer-events-none hidden md:block"
        style={{ 
          zIndex: 1,
          mixBlendMode: 'normal',
          imageRendering: 'auto'
        }}
      />
      
      {/* Coffee Sticker - Hidden on mobile, visible on desktop */}
      <img
        src="/assets/coffee-sticker.png"
        alt="Decorative coffee sticker"
        className="fixed bottom-0 left-1/4 w-48 pointer-events-none hidden md:block"
          style={{
          zIndex: 1,
          mixBlendMode: 'normal',
          imageRendering: 'auto'
          }}
        />
    </div>
  );
};

export default BackgroundShapes;